import axios, { AxiosResponse } from "axios";
import { Section } from "../models/LinkDetails";

const API_BASE_URL = "https://sspreactapi.azurewebsites.net";

// Set the authorization token in the Axios headers
const setAuthToken = (token: string | null): void => {
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
};

// Make a GET request to obtain a token
export const getToken = async (): Promise<string> => {
  try {
    const response: AxiosResponse<{ access_token: string }> = await axios.post(
      `${API_BASE_URL}/api/Login?code=5_X8SGeUM01ibXPmYRcwlTeMzN-YQzaNYxQS5rykOurgAzFuEmq9Gw==`
    );
    const token = response.data.access_token;

    // Set the obtained token in the headers for future requests
    setAuthToken(token);

    return token;
  } catch (error) {
    throw new Error("Failed to get token");
  }
};

export const validateUser = async (token: string, provider: string): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axios.post(
      `${API_BASE_URL}/api/ValidateUser?code=ciAE8WNlA_QRo5gABf9d2M-bIz7FWTYYNJx6IYeZz4UaAzFuFzKz2A==&provider=${provider}&returnid=no`,
      null,
      {
        headers: {
          token,
        },
      }
    );
    return response;
  } catch (error) {
    return {'status' : 400};
  }
};

export const fetchLinkDetails = async (): Promise<any> => {
    try {
        const response: Array<Section> = await axios.get(`${API_BASE_URL}/api/FetchLandingDetail?code=dANQBZFXqO36QppN89I-0Bn3dcz_qznDZgiNrQr8kdHOAzFu-V9O-Q==`);
        return response;
      } catch (error) {
        throw new Error("Failed to get data!");
      }
}